<template>
    <div id="TableTask">
        <div style="display: flex; gap: 10px">
            <SupsisButton primary @click="createTask" classNames="action-button">
                <span class="material-icons">assignment</span>
                {{ $t("task.createTask") }}
            </SupsisButton>
        </div>
        <KanbanList :tableRecord="recordId" ref="kanbanList" />
    </div>
</template>

<script>
import { mapActions } from "vuex";
import KanbanList from "../../../../../components/task/TaskListView.vue";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";

export default {
    name: "TableTask",
    props: {
        recordId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {};
    },
    components: {
        KanbanList,
        SupsisButton,
    },
    methods: {
        ...mapActions({
            addNewWindow: "app/addNewWindow",
        }),
        createTask() {
            const refreshTable = this.refreshTable;
            this.addNewWindow({
                type: "chat-create-task",
                title: "Görev Oluştur",
                payload: {
                    tableRecord: this.recordId,
                    onTaskCreated: () => {
                        refreshTable();
                    },
                },
            });
        },
        refreshTable() {
            this.$refs.kanbanList.getTasks();
        },
    },
};
</script>

<style lang="scss" scoped>
#TableTask {
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .action-button {
        display: flex;
        gap: 5px;
        cursor: pointer;
    }

    .supsis-button {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px 20px;
        font-size: 14px;
        font-weight: bold;
        color: #fff;
        background-color: #007bff;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        transition: background-color 0.3s;

        &:hover {
            background-color: #0056b3;
        }

        .material-icons {
            margin-right: 8px;
        }
    }
}
</style>
